exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\n.info-block {\n  border: 1px solid #efefef;\n  border-radius: 10px;\n  background: white; }\n.tag {\n  border-radius: 50%;\n  height: 15px;\n  width: 15px;\n  display: inline-block; }\n.tag-default {\n  background-color: gray; }\n.tag-success {\n  background-color: green; }\n.tag-warning {\n  background-color: orange; }\n.tag-danger {\n  background-color: red; }\n.mat-header-cell {\n  text-align: left; }\n.mat-table {\n  width: 100%; }\n.dndContainer {\n  text-align: center;\n  border: 1px #C2C2C2 dashed;\n  background: #ffffff;\n  margin-bottom: 20px; }\n.dndContainer .icon {\n    vertical-align: bottom;\n    padding-right: 12px; }\n.dndContainer .icon-browse {\n    padding-right: 12px; }\n.dndContainer div {\n    padding-bottom: 12px; }\n.dndContainer .mat-button {\n    background: #F9F9F9;\n    border-radius: 20px !important; }\n.icon-xls {\n  color: #1F6E43;\n  padding-right: 8px; }\n.no-result-display {\n  padding: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/upload-dialog/upload-dialog.component.scss
// module id = ../../../../../src/app/shared/components/upload-dialog/upload-dialog.component.scss
// module chunks = main